








import ActionButton from '@/components/ActionButton.vue'
import { message } from '@/store/modules/notifications'
import { formatDate } from '@/utils/functions'
import { GetTopUpDTO } from '@/utils/interfaces/topup.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  components: { ActionButton },
  props: {
    item: { type: Object as PropType<GetTopUpDTO>, required: true },
  },
  methods: {
    async onCopy() {
      try {
        let text = ''
        text += `${this.$t('date')}: ${formatDate(this.item.created_at)}\n`
        text += `${this.$t('number')}: ${this.item.phone_number ||
          this.item.destination_account}\n`
        text += `${this.$t('code')}: ${this.item.code}\n`
        text += `${this.$t('status')}: ${this.$t(this.item.status)}\n`
        text += `${this.$t('carrier_trans_id')}: ${this.$t(
          this.item.carrier_trans_id,
        )}\n`
        text += `${this.$t('destination_amount')}: ${this.$t(
          this.item.destination_amount,
        )}\n`
        text += `${this.$t('trans_id')}: ${this.$t(this.item.trans_id)}\n`

        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text)
        }
      } catch (error) {
        const message = {
          text: this.$t('error-copying'),
          title: 'Ups!',
          icon: 'mdi-content-copy',
          description: this.$t('error-copying'),
          color: 'error',
        } as message
        this.$store.commit('notifications/displayMessage', message)
      }
    },
  },
})
